export default "__VITE_ASSET__CHSlVIbP__"